import { useTranslation } from 'react-i18next'
import styles from './VoterOpenPositions.module.scss'

export const VoterOpenPositions = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <h1 className={styles['header']}>{t('pages.openPositions')}</h1>
    </div>
  )
}
